import { render } from "./HssePolicy.vue?vue&type=template&id=66894ff5"
import script from "./HssePolicy.vue?vue&type=script&lang=js"
export * from "./HssePolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__